var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OzBaseButton,{class:[
    /**
     * This class is defined in the `tailwind.css` file
     * so it can be used by anchors within custom strings (e.g translations).
     */
    _vm.colorPreset === _setup.OzTextLinkColorPreset.Primary && {
      'oz-text-link-light-primary': _vm.darkMode === false,
      'oz-text-link-dark-primary': _vm.darkMode === true,
      'oz-text-link-light-primary dark:oz-text-link-dark-primary': _vm.darkMode === 'auto',
    },
    _vm.colorPreset === _setup.OzTextLinkColorPreset.Secondary && {
      'oz-text-link-light-secondary': _vm.darkMode === false,
      'oz-text-link-dark-secondary': _vm.darkMode === true,
      'oz-text-link-light-secondary dark:oz-text-link-dark-secondary': _vm.darkMode === 'auto',
    },
    '!underline',
  ],attrs:{"href":_vm.href,"target":_vm.hrefTarget},on:{"mousedown":function($event){return _vm.$emit('mousedown', $event)},"keydown":function($event){return _vm.$emit('keydown', $event)},"click":function($event){return _vm.$emit('click', $event)},"focus":function($event){return _vm.$emit('focus', $event)},"blur":function($event){return _vm.$emit('blur', $event)},"touchstart":function($event){return _vm.$emit('touchstart', $event)}}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }